import { render } from "./DefEmail.vue?vue&type=template&id=bd0eae7c&scoped=true"
import script from "./DefEmail.vue?vue&type=script&lang=js"
export * from "./DefEmail.vue?vue&type=script&lang=js"

import "./DefEmail.vue?vue&type=style&index=0&id=bd0eae7c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd0eae7c"]])

export default __exports__